<template>
  <div class="flex h-2 w-2 items-center justify-center relative">
    <span class="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-500 opacity-75"></span>
    <span class="relative inline-flex rounded-full h-2 w-2 bg-amber-400"></span>
  </div>
</template>

<script>
export default {
  name: 'ChatBadge',
}
</script>
